var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "EditorDrop",
      attrs: { contenteditable: "true" },
      on: {
        keydown: _vm.onKeyDown,
        dragenter: function($event) {
          $event.preventDefault()
          return _vm.onDragEnter($event)
        },
        dragover: function($event) {
          $event.preventDefault()
          return _vm.onDragOver($event)
        },
        dragleave: function($event) {
          $event.preventDefault()
          return _vm.onDragLeave($event)
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm.onDrop($event)
        },
        paste: function($event) {
          $event.preventDefault()
          return _vm.onPaste($event)
        }
      }
    },
    [
      _c("div", { staticClass: "EditorDrop_Target" }, [
        _c(
          "svg",
          {
            staticClass: "EditorDrop_Icon",
            attrs: { width: "50", height: "43", viewBox: "0 0 50 43" }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
              }
            })
          ]
        ),
        _vm._v("\n    Drag an image or paste clipboard image here.\n  ")
      ]),
      _vm._v(" "),
      _c(
        "Portal",
        { attrs: { to: "uploadScreenImageDialog" } },
        [
          _c(
            "OverlayScreen",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowImageUploadDialog,
                  expression: "isShowImageUploadDialog"
                }
              ],
              on: { close: _vm.closeImageUploadDialog }
            },
            [
              _c("UploadImagePathDialog", {
                attrs: { defaultImageFileName: _vm.defaultImageFileName },
                on: {
                  apply: _vm.uploadImage,
                  close: _vm.closeImageUploadDialog
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }